import React from "react"
import ListPageContainer from "../../Common/jsx/ListPageContainer"
import { getEntitiesUrlParameters } from "../../Common/js/get_entities_url_parameters"
import withHooks from "../../Common/jsx/WithHooks"
import { strToSnakeCase, strToUpperSnakeCase } from "../../Common/js/string_utils"
import { getQuestions, patchQuestion } from "../../api/api_question"
import { FR, GB } from "country-flag-icons/react/3x2"
import { ucFirst } from "../../Common/js/generic_functions"

class QuestionsList extends React.Component {
  constructor(props) {
    super(props)

    this.dMgr = this.props.DebugManager(this.constructor.name)
    // this.dMgr.activate(true)
    this.dMgr.debug("const_props:", this.props)
    this.state = {
      isReadyToRender: false,
      listPagination: {
        itemsPerPage: 15,
        page: 1,
        totalItems: -1,
        firstPageUrl: "",
        lastPageUrl: "",
        previousPageUrl: "",
        nextPageUrl: "",
      },
      listOrders: {
        id: "desc",
      },
      listFilters: {
        isVisible: true,
        searchStrings: "",
      },
    }
    this.dMgr.debug("init_state:", this.state)

    this.getEntities = this.getEntities.bind(this)
    this.setEntityIsVisible = this.setEntityIsVisible.bind(this)
    this.getHeaders = this.getHeaders.bind(this)
    this.getFilters = this.getFilters.bind(this)
    this.getRows = this.getRows.bind(this)
    this.buildEntity = this.buildEntity.bind(this)
    this.listPaginationUpdate = this.listPaginationUpdate.bind(this)
    this.listOrdersUpdate = this.listOrdersUpdate.bind(this)
    this.listFiltersUpdate = this.listFiltersUpdate.bind(this)
  }

  componentDidMount() {
    this.getEntities()
  }

  async getEntities() {
    let parameters = getEntitiesUrlParameters(this.state.listPagination, this.state.listFilters, this.state.listOrders)

    // CONFIG ------------------------------------------------------------------------------------------------
    let entities = await getQuestions(parameters)
    // / CONFIG ----------------------------------------------------------------------------------------------

    let listPagination = {
      ...this.state.listPagination,
      ...{
        totalItems: entities["hydra:totalItems"],
        pageTypeUrl: entities["hydra:view"]["@id"],
        firstPageUrl: entities["hydra:view"]["hydra:first"],
        lastPageUrl: entities["hydra:view"]["hydra:last"],
        previousPageUrl: entities["hydra:view"]["hydra:previous"],
        nextPageUrl: entities["hydra:view"]["hydra:next"],
      },
    }

    this.setState({ isReadyToRender: true, listPagination, entities: entities["hydra:member"] })
  }

  async setEntityIsVisible(entity, isVisible, doneCallback) {
    await patchQuestion(entity.id, { isVisible: isVisible })

    this.getEntities()
    this.props.notif.success()
    if (doneCallback !== undefined) {
      doneCallback()
    }
  }

  // CONFIG ------------------------------------------------------------------------------------------------

  getHeaders() {
    return [
      {
        name: "id",
        title: this.props.t("form.id"),
        className: "text-center",
        sort: this.state.listOrders.id !== undefined ? this.state.listOrders.id : "",
      },
      {
        name: "statementFr",
        title: [this.props.t("form.statement"), <FR key="thFR" className="lang_flag margin-left-5" />],
        sort: this.state.listOrders.statementFr !== undefined ? this.state.listOrders.statementFr : "",
      },
      {
        name: "statementEn",
        title: [this.props.t("form.statement"), <GB key="thGB" className="lang_flag margin-left-5" />],
        sort: this.state.listOrders.statementEn !== undefined ? this.state.listOrders.statementEn : "",
      },
      {
        name: "responseFr",
        title: [this.props.t("form.response"), <FR key="thFR" className="lang_flag margin-left-5" />],
        sort: this.state.listOrders.responseFr !== undefined ? this.state.listOrders.responseFr : "",
      },
      {
        name: "responseType",
        title: this.props.t("form.responseType"),
        sort: this.state.listOrders.responseType !== undefined ? this.state.listOrders.responseType : "",
      },
      {
        name: "questionType",
        title: this.props.t("form.questionType"),
        sort: this.state.listOrders.questionType !== undefined ? this.state.listOrders.questionType : "",
      },
      {
        name: "actions",
        title: this.props.t("app.actions"),
      },
    ]
  }

  getFilters() {
    return [
      {
        name: "searchStrings",
        type: "text",
        label: this.props.t("app.search"),
        value: this.state.listFilters.searchStrings,
      },

      {
        name: "isVisible",
        type: "checkbox",
        label: this.props.t("app.hideDeleted"),
        checked: this.state.listFilters.isVisible,
      },
    ]
  }

  buildEntity(entity) {
    entity.customFields = []

    return entity
  }

  getRows() {
    return this.state.entities.map((entity) => {
      entity = this.buildEntity(entity)

      let actions = []
      if (this.props.RightsManager.userHasRight(strToUpperSnakeCase(this.props.entityType) + ":EDIT")) {
        actions = actions.concat(["edit", "delete", "restore"])
      }

      let responseFr
      let response = entity.responseChoices.filter((response) => {
        if (response.isCorrect) {
          return true
        } else {
          return false
        }
      })

      if (response[0] !== undefined) {
        responseFr = response[0]["responseFr"]
      } else {
        responseFr = ""
      }

      return {
        entity: entity,
        fields: [
          {
            name: "id",
            value: entity.id,
            className: "text-center",
          },
          {
            name: "statementFr",
            value: entity.statementFr,
          },
          {
            name: "statementEn",
            value: entity.statementEn,
          },
          {
            name: "responseFr",
            value: responseFr,
          },
          {
            name: "responseType",
            value: entity.responseType["name" + ucFirst(this.props.i18n.resolvedLanguage)],
            link: { url: "/admin/response_types/edit/" + entity.responseType.id, referrerUrl: "/admin/questions" },
          },
          {
            name: "questionType",
            value: entity.questionType["name" + ucFirst(this.props.i18n.resolvedLanguage)],
            link: { url: "/admin/question_types/edit/" + entity.questionType.id, referrerUrl: "/admin/questions" },
          },
          {
            name: "actions",
            actions: actions,
          },
        ],
      }
    })
  }
  // /CONFIG ------------------------------------------------------------------------------------------------

  listPaginationUpdate(parameters) {
    this.dMgr.debug("listPaginationUpdate parameters:", parameters)
    this.setState({ listPagination: { ...this.state.listPagination, ...parameters } }, this.getEntities)
  }

  listOrdersUpdate(order) {
    this.dMgr.debug("listOrdersUpdate order:", order)

    let listOrders = {}
    if (this.state.listOrders[order] !== undefined) {
      if (this.state.listOrders[order] === "asc") {
        listOrders[order] = "desc"
      } else {
        listOrders[order] = "asc"
      }
    } else {
      listOrders[order] = "asc"
    }
    this.setState({ listOrders: listOrders }, this.getEntities)
  }

  listFiltersUpdate(filters) {
    this.dMgr.debug("listFiltersUpdate filters:", filters)
    this.setState({ listFilters: { ...this.state.listFilters, ...filters } }, this.getEntities)
  }

  render() {
    if (!this.state.isReadyToRender) {
      this.dMgr.debug("render:", "not ready")
      return null
    }
    this.dMgr.rendering()

    let toRender = (
      <ListPageContainer
        tableName={"list_" + this.props.entitiesType}
        referrerUrl={"/admin/" + strToSnakeCase(this.props.entitiesType)}
        entityType={this.props.entityType}
        entitiesType={this.props.entitiesType}
        tableHeaders={this.getHeaders()}
        tableRows={this.getRows()}
        filters={this.getFilters()}
        listPagination={this.state.listPagination}
        listPaginationUpdate={this.listPaginationUpdate}
        listOrdersUpdate={this.listOrdersUpdate}
        listFilters={this.state.listFilters}
        listFiltersUpdate={this.listFiltersUpdate}
        deleteEntity={(entity, doneCallback) => this.setEntityIsVisible(entity, false, doneCallback)}
        restoreEntity={(entity) => this.setEntityIsVisible(entity, true)}
      />
    )

    this.dMgr.renderDone()
    return toRender
  }
}

export default withHooks(QuestionsList)
